/* FAQ category filter.

   The pills are built here rather than stored in the page body: Shopify
   sanitises page content and strips <button> elements and the wrapper
   attributes, so anything interactive has to come from the theme.
   Groups are derived from the rendered .faq-cat / .faq-list pairs.
   No-ops on any page without them. */
(function () {
  function slug(s) {
    return s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }

  function init() {
    var cats = document.querySelectorAll('.rte .faq-cat, .faq-cat');
    if (cats.length < 2) return;

    var groups = [];
    cats.forEach(function (h) {
      var list = h.nextElementSibling;
      if (!list || !list.classList.contains('faq-list')) return;
      var wrap = document.createElement('div');
      wrap.className = 'faq-group';
      wrap.setAttribute('data-cat', slug(h.textContent));
      h.parentNode.insertBefore(wrap, h);
      wrap.appendChild(h);
      wrap.appendChild(list);
      groups.push({ el: wrap, key: slug(h.textContent), label: h.textContent.trim() });
    });
    if (!groups.length) return;

    var bar = document.createElement('ul');
    bar.className = 'faq-filters';

    function pill(key, label, on) {
      var li = document.createElement('li');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'faq-pill';
      b.setAttribute('data-filter', key);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.textContent = label;
      li.appendChild(b);
      return li;
    }

    bar.appendChild(pill('all', 'All', true));
    groups.forEach(function (g) { bar.appendChild(pill(g.key, g.label, false)); });
    groups[0].el.parentNode.insertBefore(bar, groups[0].el);

    bar.addEventListener('click', function (e) {
      var btn = e.target.closest('.faq-pill');
      if (!btn) return;
      var want = btn.getAttribute('data-filter');

      bar.querySelectorAll('.faq-pill').forEach(function (p) {
        p.setAttribute('aria-pressed', String(p === btn));
      });

      groups.forEach(function (g) {
        var match = want === 'all' || g.key === want;
        g.el.hidden = !match;
        if (!match) {
          g.el.querySelectorAll('details[open]').forEach(function (d) { d.open = false; });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* --- header menus open on hover ------------------------------------------

   The header's dropdowns are <details> elements, so out of the box they are
   click-to-open / click-again-or-outside-to-close. On a real pointer they
   should open on hover instead.

   This only sets and clears the `open` attribute, so:
     - the native <details> behaviour is untouched,
     - `toggle` still fires, so Dawn's own header-menu handlers keep working,
     - touch and keyboard are unaffected (the media query gates hover, and
       keyboard activation is detected by event.detail === 0 and left alone).

   A short close delay covers the gap between the summary and the panel, so
   moving the pointer down into the panel does not shut it. */
(function () {
  var HOVER = window.matchMedia('(hover: hover) and (pointer: fine)');
  var CLOSE_DELAY = 140;

  function wire() {
    var menus = document.querySelectorAll('.header__inline-menu details');
    if (!menus.length) return;

    menus.forEach(function (details) {
      var timer = null;
      var summary = details.querySelector('summary');

      function open() {
        clearTimeout(timer);
        if (!HOVER.matches || details.hasAttribute('open')) return;
        // only one top-level menu at a time
        menus.forEach(function (other) {
          if (other !== details) other.removeAttribute('open');
        });
        details.setAttribute('open', '');
      }

      function scheduleClose() {
        if (!HOVER.matches) return;
        clearTimeout(timer);
        timer = setTimeout(function () { details.removeAttribute('open'); }, CLOSE_DELAY);
      }

      details.addEventListener('mouseenter', open);
      details.addEventListener('mouseleave', scheduleClose);

      if (summary) {
        // A pointer click on an already-hovered summary would toggle it shut
        // straight away. Hover owns the state on pointer devices, so swallow
        // that click - but only a real one: keyboard Enter/Space reports
        // detail 0 and must still toggle natively.
        summary.addEventListener('click', function (e) {
          if (HOVER.matches && e.detail > 0) e.preventDefault();
        });
      }
    });

    // Escape closes whatever is open, as it did before.
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      menus.forEach(function (d) { d.removeAttribute('open'); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wire);
  } else {
    wire();
  }
})();

/* --- section behaviour, bound so the theme editor keeps working -----------

   These used to be inline <script> blocks inside their sections. The editor
   re-renders a section by replacing its markup, and a script inserted that way
   never runs - so editing the guides or the store list would leave the tabs and
   the locator dead until a full reload. Dawn's own convention is to rebind on
   `shopify:section:load`, which is what happens here.

   Each initialiser is idempotent. The flag lives in a WeakSet rather than a
   data- attribute: an attribute serialises, so a re-render that round-trips the
   markup carries the "already wired" mark onto brand new nodes and the rebind
   is skipped - which is exactly the failure this code exists to prevent. A
   WeakSet keys on the node object, so a fresh node is always treated as fresh
   and the entry is released when the old node is collected. */
(function () {
  var wired = new WeakSet();

  function guideTabs(scope) {
    (scope || document).querySelectorAll('[data-guide-tabs]').forEach(function (root) {
      if (wired.has(root)) return;
      wired.add(root);
      var tabs = [].slice.call(root.querySelectorAll('.gt__tab'));
      var panels = [].slice.call(root.querySelectorAll('.gt__panel'));

      function select(i) {
        tabs.forEach(function (t, j) {
          var on = i === j;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          if (panels[j]) panels[j].hidden = !on;
        });
      }

      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(i); });
        t.addEventListener('keydown', function (e) {
          var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!d) return;
          e.preventDefault();
          var n = (i + d + tabs.length) % tabs.length;
          select(n);
          tabs[n].focus();
        });
      });
    });
  }

  function storeLocations(scope) {
    (scope || document).querySelectorAll('[data-store-locations]').forEach(function (root) {
      if (wired.has(root)) return;
      wired.add(root);
      // the dialogs are siblings of the grid, so scope to the whole section
      var section = root.closest('.shopify-section') || document;
      var photos = [].slice.call(root.querySelectorAll('.sl__photo'));
      var names = [].slice.call(root.querySelectorAll('[data-store-index]'));
      var dialogs = [].slice.call(section.querySelectorAll('.sl__dialog'));

      function show(i) {
        photos.forEach(function (p, j) { p.classList.toggle('sl__photo--active', j === i); });
        names.forEach(function (n, j) { n.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
      }

      names.forEach(function (n, i) {
        n.addEventListener('click', function () { show(i); });
      });

      section.querySelectorAll('[data-store-details]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var i = parseInt(btn.getAttribute('data-store-details'), 10);
          show(i);
          var dlg = dialogs[i];
          if (!dlg) return;
          if (typeof dlg.showModal === 'function') dlg.showModal();
          else dlg.setAttribute('open', '');
        });
      });

      section.querySelectorAll('[data-store-close]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dlg = btn.closest('dialog');
          if (!dlg) return;
          if (typeof dlg.close === 'function') dlg.close();
          else dlg.removeAttribute('open');
        });
      });
    });
  }

  function initAll(scope) {
    guideTabs(scope);
    storeLocations(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
